import { Modal } from "antd";
import React from "react";
import "./custom.scss";

const BannerPreviewModal = (props) => {
  const { visible, onCancel, imageUrl, adType, videoType } = props;

  // console.log(imageUrl)

  return (
    <Modal
      title="Banner Preview"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      className="preview-modal banner"
    >
      <div className="view-banner-container">
        {adType === "video" ? (
          videoType === "local" ? (
            <video
              src={imageUrl}
              controls
              width="100%"
              style={{
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
            />
          ) : (
            <iframe
              width="100%"
              height="315"
              src={`https://www.youtube.com/embed/${getYoutubeId(imageUrl)}`}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{ borderRadius: "4px" }}
            />
          )
        ) : (
          <img src={imageUrl} />
        )}
      </div>
    </Modal>
  );
};

export default BannerPreviewModal;
